import { render, staticRenderFns } from "./ViewTournaments.vue?vue&type=template&id=33da76cc&scoped=true"
import script from "./ViewTournaments.vue?vue&type=script&lang=js"
export * from "./ViewTournaments.vue?vue&type=script&lang=js"
import style0 from "./ViewTournaments.vue?vue&type=style&index=0&id=33da76cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33da76cc",
  null
  
)

export default component.exports